/** CDN-ассеты credit selection, общие для нескольких features */
export const CREDIT_SELECTION_HISTOGRAM_SRC = 'https://s44751.cos.ngenix.net/mpl/credit_selection/histogram.svg';
